import { render, staticRenderFns } from "./levelThreePage.vue?vue&type=template&id=472dd944&scoped=true&"
import script from "./levelThreePage.vue?vue&type=script&lang=js&"
export * from "./levelThreePage.vue?vue&type=script&lang=js&"
import style0 from "./levelThreePage.vue?vue&type=style&index=0&id=472dd944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dd944",
  null
  
)

export default component.exports